"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MaskToCidr_1 = require("./MaskToCidr");
var CidrInfo_1 = require("./CidrInfo");
function subnetInfo(ipaddress, mask) {
    var cidr = MaskToCidr_1.maskToCidr(mask);
    var subnetCidr = ipaddress + '/' + cidr;
    return CidrInfo_1.cidrInfo(subnetCidr);
}
exports.subnetInfo = subnetInfo;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3VibmV0SW5mby5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlN1Ym5ldEluZm8udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFDQSwyQ0FBeUM7QUFDekMsdUNBQXFDO0FBRXJDLG9CQUE0QixTQUFpQixFQUFFLElBQVk7SUFDekQsSUFBSSxJQUFJLEdBQUcsdUJBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQTtJQUMzQixJQUFJLFVBQVUsR0FBRyxTQUFTLEdBQUcsR0FBRyxHQUFHLElBQUksQ0FBQTtJQUN2QyxNQUFNLENBQUMsbUJBQVEsQ0FBQyxVQUFVLENBQUMsQ0FBQTtBQUM3QixDQUFDO0FBSkQsZ0NBSUMifQ==


//////////////////
// WEBPACK FOOTER
// ./src/SubnetInfo.ts
// module id = 18
// module chunks = 0